export const API_BASE_URL = process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_LIVE_BASE_URL : process.env.REACT_APP_LIVE_BASE_URL_DEV;
export const API_BASE_URL_V2 = process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_LIVE_BASE_URL_V2 : process.env.REACT_APP_LIVE_BASE_URL_DEV_V2;
export const SERVICES_API = process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_SERVICE_API : process.env.REACT_APP_SERVICE_API_DEV;
export const RECURLY_PUBLIC_KEY = process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_RECURLY_PUBLIC_KEY : process.env.REACT_APP_RECURLY_PUBLIC_KEY_DEV;
export const Months = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export const MonthsFull = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December"
};


export const week = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const weekFull = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const programLevels = ["", "BEGINNER", "MODERATE", "ADVANCED"];
export const programs = ["", "BUILD", "FLEX", "LOW BACK", "NECK"];
export const indiPrograms = ["", "BUILD", "FLEX", "LOW BACK", "NECK"];

export const genders = {
  M: "Male",
  F: "Female",
  O: "Gender not listed",
  GNL: "Gender not listed",
  PNTS: "Prefer not to say",
};

export const validations = {
  usernameRegex: /^[a-z0-9A-Z_.]+$/,
  passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/,
  emailRegex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  postalCodeRegex: /^\d{5}(-\d{4})?$/,
  usernameValidation: "Username should not be empty",
  firstnameValidation: "First name should not be empty",
  GenderValidation: "Please select gender",
  lastnameValidation: "Last name should not be empty",
  postalcodeValidation: "Postal code should not be empty",
  emailValidation: "Email should not be empty",
  userNameLengthValidation: "Username must contain atleast 2 characters",
  firstNameLengthValidation: "First name must contain atleast 2 characters",
  lastNameLengthValidation: "Last name must contain atleast 2 characters",
  postalcodeLengthValidation: "Postal code must be atleast 5 characters",
  usernameRegexValidation: "Username should not contain special characters",
  passwordValidation: "Password should not be empty",
  passwordValidation2: "Min. of 6 characters, alteast 1[A-Z], 1[0-9], & 1[!-*].",
  passwordRegexValidation:
    "Password must contain atleast one special character,one uppercase letter,one number and minimum 6 characters long.",
  emailRegexValidation: "Email is invalid",
  passwordMatchValidation: "Both passwords must match",
};

export const calculateDateFromTrialPeriod = (trialdays, unit) => {
  let newDate;
  if (unit == "months") {
    var d = new Date();

    newDate = d.setMonth(d.getMonth() + trialdays);
  } else {
    newDate = new Date(new Date().getTime() + trialdays * 24 * 60 * 60 * 1000);
  }
  var newFormattedDate = new Date(newDate);
  var today = new Date();
  var date =
    newFormattedDate.getDate() +
    "/" +
    (newFormattedDate.getMonth() + 1) +
    "/" +
    today.getFullYear();
  return date;
};

export const calculateDateFromTrialPeriodFormat = (trialdays, unit) => {
  let newDate;
  if (unit == "months") {
    var d = new Date();
    newDate = d.setMonth(d.getMonth() + trialdays);
  } else {
    newDate = new Date(new Date().getTime() + trialdays * 24 * 60 * 60 * 1000);
  }
  var newFormattedDate = new Date(newDate);

  var today = new Date();
  var date =
    newFormattedDate.toLocaleString("default", { month: "long" }) +
    " " +
    newFormattedDate.getDate() +
    ", " +
    today.getFullYear();
  return date;
};

export const convertCurrencySymbols = (currencyName) => {
  var currency_symbols = {
    USD: "$", // US Dollar
    EUR: "€", // Euro
    CRC: "₡", // Costa Rican Colón
    GBP: "£", // British Pound Sterling
    ILS: "₪", // Israeli New Sheqel
    INR: "₹", // Indian Rupee
    JPY: "¥", // Japanese Yen
    KRW: "₩", // South Korean Won
    NGN: "₦", // Nigerian Naira
    PHP: "₱", // Philippine Peso
    PLN: "zł", // Polish Zloty
    PYG: "₲", // Paraguayan Guarani
    THB: "฿", // Thai Baht
    UAH: "₴", // Ukrainian Hryvnia
    VND: "₫", // Vietnamese Dong
  };

  // var currency_name = "INR";

  if (currency_symbols[currencyName] !== undefined) {
    return currency_symbols[currencyName];
  }
};

export const getDateFormat = (date) => {
  var newFormattedDate = new Date(date);
  var date =
    newFormattedDate.getFullYear() +
    "-" +
    (newFormattedDate.getMonth() + 1) +
    "-" +
    newFormattedDate.getDate();

  return date;
};

// export const parseJSON = (content) => {

//   let parsed = null;
//   try {
//     parsed = JSON.parse(content);
//   } catch (error) {

//     try {
//       // let fixedJson = content.replace(/'/g, '"');
//       let fixedJson = content.replace(/(\w+):/g, '"$1":');
//       fixedJson = fixedJson.replace(/,\s*([\]}])/g, '$1');

//       parsed = JSON.parse(fixedJson);
//     } catch (error2) {
//       parsed = null;
//     }

//   }

//   return parsed;
// }
